import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { UserDataProvider, UserProfileCom } from "../UserInLineEditView";
import RInput from "../../../../components/RInput";
import { Autocomplete, Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, Icon, IconButton, Paper, Tab, Tabs, TextField, Typography, Modal, Snackbar, Alert } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { getAllUsersData, getUserWalletData } from "../../../../API/UsersAPI/UsersApi";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { saveAs } from "file-saver";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./UserWalletTransactions.css";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { generateOtp, createTransaction } from '../../../../API/Transactions/TransactionsAPI';

const recordCountSelecter = [10, 15, 20, 25, 30];
function UserWalletTransactions(props) {
  const navigator = useNavigate();
  const token = sessionStorage.getItem("token");
  // console.log(token);
  const { userData } = useContext(UserDataProvider)
  const [userWalletData, setUserWalletData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [recordCount, setRecordCount] = useState(recordCountSelecter[0]);
  const [period, setPeriod] = useState("7");
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  // alert(startDate)
  const [loading, setLoading] = useState(true);
  // console.log(userData)

  const [modalOpen, setModalOpen] = useState(false);
  const [currencyType, setCurrencyType] = useState("COINS");
  const [transactionType, setTransactionType] = useState(""); // debit or credit
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState(1);
  const [message, setMessage] = useState("");
  const [consentChecked, setConsentChecked] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState('');
  const [timeLeft, setTimeLeft] = useState(600);
  const [otpGenLoading, setOtpGenLoading] = useState(false);
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [openSanackbar,setOpenSnackbar] = useState(false);
  const [snackbarMessage,setSnackbarMessage] = useState('');
  const [snackbarSeverity,setSnackbarSeverity] = useState('success');

  useEffect(() => {
    if(searchTerm?.length >= 4 && currencyType){
      getAllUsersData(token, pageCount, recordCount, searchTerm)
      .then((res) => {
        if (typeof res.data === "object") {
          setSearchResults(res.data.map((item) => {
            return { Actions: item._id, ...item }
          }));

        }

        // alert(typeof res.data)
        console.log("data fetched", res);
        // alert("users data fetched");
        setLoading(false);
      })
      .catch((error) => {
        // alert("users data fetched" + error);
        console.log("error",error);
        setLoading(false);
        setSearchResults([])
      });
    }
  
  }, [currencyType,searchTerm]);

  // Start countdown when OTP modal opens
  useEffect(() => {
    let timer;

    if (isOtpModalOpen) {
      setTimeLeft(600); // reset timer to 10 mins when modal opens
      timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isOtpModalOpen]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };


  const openModal = (action) => {
    setTransactionType(action);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSearchTerm("");
    // setSearchResults([]);
    // setSelectedUser(null);
    // setMessage("");
  };

  const handleCheckboxChange = (event) => {
    setConsentChecked(event.target.checked);
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);

    if (term.length < 4) {
      // setSearchResults([]);
      return;
    }
    if(term?.length >= 4){
      getAllUsersData(token, pageCount, recordCount, term)
      .then((res) => {
        if (typeof res.data === "object") {
          setSearchResults(res.data.map((item) => {
            return { Actions: item._id, ...item }
          }));

        }

        // alert(typeof res.data)
        console.log("data fetched", res);
        // alert("users data fetched");
        setLoading(false);
      })
      .catch((error) => {
        // alert("users data fetched" + error);
        console.log("error");
        setLoading(false);
        setSearchResults([])
      });
    }
   

  };


  const handleTabChange = (event, newValue) => {
    setCurrencyType(newValue);
    setAmount("");
    setMessage("");
  };

  const handleSubmit = async () => {
    // if (!selectedUser) return alert("Please select a user.");
    if (!message.trim()) {
      setMessageError(true);
      return;
    }

    setMessageError(false);
    if (consentChecked) {
      setOtpGenLoading(true);
      setSnackbarMessage('');
      setSnackbarSeverity('success');
      generateOtp(token)
        .then((res) => {
          console.log(res?.data);
          closeModal();
          setIsOtpModalOpen(true);
          setOpenSnackbar(true);
          setSnackbarSeverity('success');
          setSnackbarMessage(res?.data?.message);
          setOtpGenLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setOtpGenLoading(false);
          setOpenSnackbar(true);
          setSnackbarSeverity('error');
          setSnackbarMessage("TryAgain,OTP Generation Failed!");
        })
    }
   
    console.log(selectedUser);
  };

  const handleVerifyOtp = async () => {
    // if (!selectedUser) return alert("Please select a user.");
    const payload = {
      amount: amount,
      currencyType: currencyType,
      fromUserId: '',
      toUserId: '',
      transactionType: transactionType,
      description: message ?? 'Test description',
      otp: otp
    };

    if(transactionType === 'credit' && !selectedUser)
      {
        payload.toUserId = userData?._id;
        payload.fromUserId = null
      }
      else if(transactionType === 'debit' && !selectedUser)
      {
        payload.toUserId = null;
        payload.fromUserId = userData?._id
      }
       
      else if(transactionType === 'credit' && selectedUser)
      {
        payload.toUserId = userData?._id;
        payload.fromUserId = selectedUser?._id
      }
       
      else if(transactionType === 'debit' && selectedUser)
      {
        payload.toUserId = selectedUser?._id
        payload.fromUserId = userData?._id;
      }

  
    console.log(payload);
    setSnackbarSeverity('success');
    setSnackbarMessage('');
    createTransaction(token, payload)
      .then((res) => {
        console.log('OTP Verified', res?.data);
        setIsOtpModalOpen(false);
        setOpenSnackbar(true);
        setSnackbarSeverity('success');
        setSnackbarMessage(res?.data?.message);
        setSelectedUser(null);
      })
      .catch((err) => {
        console.log(err);
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
        setSnackbarMessage(err?.response?.data?.message);
      })
  };



  useEffect(() => {
    const token = sessionStorage.getItem("token");
    console.log(token);
    setLoading(true);
    console.log("params :", token, userData?._id, pageCount,
      recordCount, period,
      startDate.toString(),
      endDate.toString())

    getUserWalletData(
      token,
      currencyType,
      userData?._id,
      pageCount,
      recordCount,
      period,
      startDate.toString(),
      endDate.toString()
    )
      .then((res) => {
        if (typeof res.data === "object") {
          setUserWalletData(
            res.data.map((item) => {
              return { ...item };
            })
          );
        }
        // alert(typeof res.data)
        console.log("data fetched", res);
        // alert("users data fetched");
        setLoading(false);
      })
      .catch((error) => {
        // alert("users data fetched" + error);
        console.log("error");
        setLoading(false);
        setUserWalletData([])
      });
  }, [pageCount, currencyType, recordCount, period,
    startDate,
    endDate]);

  const handleJsonExport = () => {
    try {
      if (userWalletData && Object.keys(userWalletData).length > 0) {

        const json = JSON.stringify(userWalletData ?? {});
        const blob = new Blob([json], { type: "application/json;charset=utf-8;" });
        saveAs(blob, `${userData?.username}-BalanceHistory.json`);
      }
      else {
        alert("No Balance History data available to export.")
      }
    } catch (err) {
      console.error("Error converting JSON to file:", err);
    }
  };

  const getColumns = () => {
    const filteredEntries = Object.entries(
      Object.assign({}, ...userWalletData)
    ).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    const dataKeys = Object.keys(filteredObject);
    return dataKeys.map((item, index) => {
      return index === 0
        ? {
          field: item,
          headerName: item,
          align: "center",
          headerAlign: "center",
          sortable: false,
          editable: false,
          // renderCell: (params) => {
          //   return <CustomCellComponent value={params.value} />;
          // },
          width: 150,
        }
        : {
          field: item,
          headerName: item,
          align: "center",
          headerAlign: "center",
          sortable: false,
          editable: true,
        };
    });
  };

  const columns: GridColDef[] = [...getColumns()];

  const rows = userWalletData.map((item, index) => {
    const filteredEntries = Object.entries(item ?? {}).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    return { ...filteredObject, id: index };
  });


  return (
    <>

      {/* OTP Modal */}

      <Dialog
        open={isOtpModalOpen}
        fullWidth
        maxWidth="sm"
        scroll="paper"
        onClose={() => setIsOtpModalOpen(false)}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Enter OTP
          <IconButton
            aria-label="close"
            onClick={() => setIsOtpModalOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <AiOutlineClose />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Please enter the 6-digit OTP sent to your registered Email.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Time remaining: <strong>{formatTime(timeLeft)}</strong>
          </Typography>

          <TextField
            label="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            inputProps={{ maxLength: 6, style: { textAlign: 'center', letterSpacing: '6px', fontSize: '1.5rem' } }}
            sx={{ width: '200px', mt: 1 }}
            variant="outlined"
          />

          <Button
            variant="info"
            color="success"
            onClick={handleVerifyOtp}
            disabled={timeLeft === 0 || otp.length !== 6}
            sx={{ mt: 2 }}
          >
            Verify OTP
          </Button>

          {timeLeft === 0 && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              OTP expired. Please resend.
            </Typography>
          )}
        </DialogContent>
      </Dialog>

      <Snackbar
        anchorOrigin={{vertical:"top",horizontal:'center'}}
        open={openSanackbar}
        autoHideDuration={6000}
        onClose={()=>{setOpenSnackbar(false)}}
        message={snackbarMessage}
        action={snackbarSeverity}
            >
                 <Alert
                    onClose={()=>{setOpenSnackbar(false)}}
                    severity={snackbarSeverity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                {snackbarMessage}
            </Alert>
      </Snackbar>

      <Dialog open={modalOpen} onClose={closeModal} fullWidth maxWidth="sm" scroll="paper">
        <DialogTitle>
          {transactionType === "debit" ? "Debit From this User" : "Credit to this User"}
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <AiOutlineClose />
          </IconButton>
          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
            <div>
              <Typography variant="caption">Avail Coins: {userData?.coinsWalletDetils?.availableAmount ?? 0}</Typography>
            </div>

            <div>
              <Typography variant="caption">Avail Karats: {userData?.walletDetils?.availableAmount ?? 0.00}</Typography>
            </div>
          </Box>

        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Current Username: <strong>{userData.username}</strong>
          </Typography>

          {/* Currency Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={currencyType}
              onChange={handleTabChange}
              variant="fullWidth"
            >
              <Tab label="Coins" value="COINS" />
              <Tab label="Karats" value="KARATS" />
            </Tabs>
          </Box>


          {/* Content changes based on selected tab */}
          {currencyType === "COINS" && (
            <Box>
              <TextField
                sx={{ mb: 2 }}
                fullWidth
                label="Amount (Coins)"
                type="number"
                value={amount}
                error={amount <= 0}
                helperText={amount <= 0 ? "Amount must be greater than 0.00" : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  // Allow numbers with optional decimal (e.g., 1, 0.5, 3.25)
                  if (/^\d*\.?\d*$/.test(val)) {
                    setAmount(val);
                  }
                }}
                inputProps={{ min: 1 }}
              />
              {/* You can also render other coin-specific UI here */}
            </Box>
          )}

          {currencyType === "KARATS" && (
            <Box>
              <TextField
                sx={{ mb: 2 }}
                fullWidth
                label="Amount (Karats)"
                type="number"
                value={amount}
                error={amount <= 0}
                helperText={amount <= 0 ? "Amount must be greater than 0" : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  // Allow numbers with optional decimal (e.g., 1, 0.5, 3.25)
                  if (/^\d*\.?\d*$/.test(val)) {
                    setAmount(val);
                  }
                }}
                inputProps={{ min: 1 }}
              />
              {/* You can also render other karats-specific UI here */}
            </Box>
          )}
          <Autocomplete
            options={searchResults}
            getOptionLabel={(option) => option.username}
            onInputChange={(e, value) => handleSearch(value)}
            onChange={(e, value) => setSelectedUser(value)}
            renderInput={(params) => (
              <TextField {...params} label="Search From User (Please Enter four Characters to search)" variant="outlined" />
            )}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Transaction Message"
            multiline
            rows={3}
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              if (e.target.value.trim()) {
                setMessageError(false); // clear error while typing
              }
            }}
            error={messageError}
            helperText={messageError ? 'Transaction message is required' : ''}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={consentChecked}
                onChange={handleCheckboxChange}
                name="consent"
              />
            }
            label={<Typography
              sx={{
                color: "#e20a0a",
                fontSize: "0.85rem",
              }}
            >
              I understand that this transaction cannot be undone.
            </Typography>}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} variant="danger">Cancel</Button>
          <Button onClick={handleSubmit} variant="success" disabled={!consentChecked} >{otpGenLoading?'submitting...':'Submit'}</Button>
        </DialogActions>
      </Dialog>
      <Row>
        <Col xs={2}>
          <UserProfileCom />
          <div className="Nav-hdr">
            <Button
              onClick={() => openModal("debit")}
              style={{ borderRadius: 15, margin: "0 10px" }}
              variant="outline-danger"
            ><FaMinusCircle style={{ marginRight: "8px" }} />Debit this User</Button>
            <Button
              onClick={() => openModal("credit")}
              style={{ borderRadius: 15, margin: "0 10px" }}
              variant='outline-success'
            ><FaPlusCircle style={{ marginRight: "8px" }} />Credit this User</Button>
          </div>
        </Col>
        <Col xs={10}>
          <div>
            <div>
              <h1 className="sideHeadingSty">Balances</h1>
              <div>
                <Row className="input-row">
                  <Col xs={4}>
                    <RInput lable={"Total Balance _id: " + userData?.walletDetils?._id} disabled={true} value={(userData?.walletDetils?.availableAmount + userData?.walletDetils?.inPlayAmount).toFixed(2)} />
                  </Col>
                  <Col xs={4}>
                    <RInput lable={"Current Available Funds"} disabled={true} value={(userData?.walletDetils?.availableAmount.toFixed(2))} />
                  </Col>
                  <Col xs={4}>
                    <RInput lable={"Current In-Play Funds"} disabled={true} value={userData?.walletDetils?.inPlayAmount.toFixed(2)} />
                  </Col>
                </Row>
              </div>
              <div>
                <Row className="input-row">
                  <Col xs={4}>
                    <RInput lable={"Total Coins _id: " + userData?.coinsWalletDetils?._id} disabled={true} value={(userData?.coinsWalletDetils?.availableAmount + userData?.coinsWalletDetils?.inPlayAmount).toFixed(2)} />
                  </Col>
                  <Col xs={4}>
                    <RInput lable={"Current Available Coins"} disabled={true} value={userData?.coinsWalletDetils?.availableAmount.toFixed(2)} />
                  </Col>
                  <Col xs={4}>
                    <RInput lable={"Current In-Play Coins"} disabled={true} value={(userData?.coinsWalletDetils?.inPlayAmount)?.toFixed(2)} />
                  </Col>
                </Row>
              </div>
            </div>

            <h1 className="sideHeadingSty">User Metrics & Returns</h1>
            <div style={{ width: "19vw" }}>
              <RInput lable={"Current In-Play Funds"} disabled={true} />
              <RInput lable={"Current Login"} disabled={true} />
            </div>
          </div>
        </Col>
      </Row>
      <div>
        <div>
          <Row className="input-row">
            <Col xs={10}>
              <h1 className="sideHeadingSty" style={{ marginLeft: "1%" }}>
                Balance History
              </h1>
            </Col>
            <Col xs={2} >
              <Button id="button-addon2" style={{ backgroundColor: "#0079FF", color: "white", border: "none", marginLeft: 10 }} onClick={() => { handleJsonExport() }}>
                Export Json
              </Button>
            </Col>
          </Row>
        </div>
        <div>
          <Row
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "1.5%",
            }}
          >
            <Col>
              {["7", "30", "60", "Lifetime"].map((value) => {
                return (
                  <Button
                    style={{ borderRadius: 15, margin: "0 10px" }}
                    variant="outline-secondary"
                    active={period === value}
                    onClick={() => {
                      setPageCount(1); setPeriod(value);
                      if (value === "Lifetime") {
                        setStartDate(dayjs("2024-04-01"));
                      }
                      else {
                        setStartDate(dayjs().subtract(value, "days"));
                      }
                      setEndDate(dayjs(new Date()))
                    }}
                    disabled={loading}
                  >
                    {value === "Lifetime" ? value : `Last ${value} Days`}
                  </Button>
                );
              })}
            </Col>

            <Col xs={3}>
              {["COINS", 'KARATS'].map((value) => {
                return (
                  <Button
                    style={{ borderRadius: 15, margin: "0 10px", backgroundColor: currencyType !== value && "transparent", color: currencyType !== value && "black" }}
                    variant={value === "KARATS" ? "success" : "warning"}
                    active={currencyType === value}

                    onClick={() => {
                      setCurrencyType(value);
                    }}
                    disabled={loading}

                  >
                    {value}
                  </Button>
                );
              })}

            </Col>

            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(newValue) => { setPeriod(""); setPageCount(1); setStartDate(newValue); }}
                    minDate={dayjs("2024-04-01")}
                    maxDate={dayjs(new Date())}
                    disabled={loading}
                  />
                </LocalizationProvider>
              </div>
              <div style={{ marginLeft: "1%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={(newValue) => { setPeriod(""); setPageCount(1); setEndDate(newValue); }}
                    minDate={dayjs("2024-04-01")}
                    maxDate={dayjs(new Date())}
                    disabled={loading}
                  />
                </LocalizationProvider>
              </div>
            </Col>
          </Row>
        </div>
        <Paper sx={{ height: "65vh", width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                // paginationModel: { pageSize: recordCount },
                meta: { hasNextPage: true },
              },
            }}
            pageSizeOptions={[5, 10, 15]}
            paginationMode="client"
            pagination
            // estimatedRowCount={500}
            // hideFooterSelectedRowCount={true}
            rowSpacingType="border"
            // autoPageSize
            hideFooterPagination
            hideFooter
            rowCount={1000}
            onPaginationMetaChange={() => {
              alert("changed");
            }}
            // checkboxSelection
            sx={{ border: 0 }}
            loading={loading}
            onProcessRowUpdateError={(error) => {
              alert("on Process Row Update Error");
            }}
            disableRowSelectionOnClick
            onPaginationModelChange={(model) => {
              // setPaginationModel(model);
              // console.log(model);
              // getMoreData();
            }}
            onRowDoubleClick={(item) => {
              alert(item?.row?._id);
            }}
          // autosizeOptions={{
          //     columns: ['dob', 'status', 'createdBy'],
          //     includeOutliers: false,
          //     includeHeaders: false,
          //   }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "1%",
              paddingRight: "2%",
            }}
          >
            <div
              style={{
                width: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: "0", color: "black", margin: "0 0.5vw" }}>
                  Row per page
                </p>
              </div>

              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Form.Select
                  size="sm"
                  onChange={(event) => {
                    setRecordCount(event.target.value);
                  }}
                  disabled={loading}
                >
                  {recordCountSelecter.map((value, index) => {
                    return <option key={index + "values"}>{value}</option>;
                  })}
                </Form.Select>

                <p
                  style={{ margin: "0", color: "black", margin: "0 0.5vw" }}
                ></p>
              </div>
              <Button
                onClick={() => {
                  setPageCount((page) => page - 1);
                }}
                disabled={pageCount <= 1 || loading}
              >
                <HiOutlineArrowSmLeft />
              </Button>

              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: "0", color: "black", margin: "0 0.5vw" }}>
                  {pageCount}
                </p>
              </div>

              <Button
                onClick={() => {
                  // getMoreData();
                  setPageCount((page) => page + 1);
                }}
                disabled={loading}
              >
                <HiOutlineArrowSmRight />
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
}

export default UserWalletTransactions;
